import * as React from 'react';
import { observer } from 'mobx-react';
import { RecordedAchBankAccountPaymentMethod } from './payment-entry-model';
import { FormControlLabelled, FormControlType } from '../../../components/form-controls/form-control-labelled';
import { ModelMetadata } from '../../virtual-terminal-generated';

@observer
export class PaymentMethodRecordedAch extends React.Component<{ achBankAccount: RecordedAchBankAccountPaymentMethod }, {}> {
	render() {
		const { paymentReference } = this.props.achBankAccount;

		return (
			<div className="vt-payment-method">
				<FormControlLabelled label="Payment reference (optional)"
					formControlProps={{
						formControlType: FormControlType.Text,
						name: ModelMetadata.RecordedACHModel.Reference.propertyName,
						placeholder: 'Enter a payment reference',
						type: 'text',
						value: paymentReference,
						onChangeHandler: this.handlePaymentReferenceChange,
						maxLength: this.referenceValidationRules.length.parameters.max,
						validationRules: this.referenceValidationRules,
						acceptanceTestTargetId: 'payment reference - ach - recorded'
					}} />
			</div>
		);
	}

	private handlePaymentReferenceChange = (event: React.FormEvent<HTMLInputElement>) => {
		this.props.achBankAccount.updatePaymentReference(event.currentTarget.value);
	}

	private get referenceValidationRules() {
		return ModelMetadata.RecordedACHModel.Reference.validationRules;
	}
}
